export const KIM_MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const KIM_MAX_NUMBER_OF_FILES = 3;

// Single-document formats Kim can ingest directly.
export const KIM_ALLOWED_FILE_TYPES = ['.pdf', '.doc', '.docx'];

// MIME-typed accept map for react-dropzone's `accept` option.
export const KIM_DROPZONE_ACCEPT: Record<string, string[]> = {
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
};

// Comma-separated extension list for the native <input type="file" accept="..."> attribute.
export const KIM_FILE_INPUT_ACCEPT = KIM_ALLOWED_FILE_TYPES.join(',');

const KIM_FILE_ICON_FALLBACK = 'material-icon-theme--document text-gray-400';

// Icon classes come from the material-icon-theme iconify pack (see index.css).
const KIM_FILE_ICON_BY_EXTENSION: Record<string, string> = {
  pdf: 'material-icon-theme--pdf text-red-400',
  doc: 'material-icon-theme--word text-blue-400',
  docx: 'material-icon-theme--word text-blue-400',
};

export function getKimFileIconClass(extension: string): string {
  const normalised = extension.toLowerCase().replace(/^\./, '');
  return KIM_FILE_ICON_BY_EXTENSION[normalised] ?? KIM_FILE_ICON_FALLBACK;
}
